import styled from 'styled-components';

/** Subtle callout holding the AI's "worth noting" list under the summary. */
export const NotesBox = styled.div`
  background: ${({ theme }) => theme.transparentBlue};
  border-radius: 12px;
  padding: 12px 16px;
`;
